import { InjectionToken } from '@angular/core';
import Rollbar from 'rollbar';

export const RollbarService = new InjectionToken<Rollbar>('rollbar');



